var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('DBox',{attrs:{"id":'cmp-td-contact-relations',"addButton":false,"addLink":true,"addLinkLabel":("" + (_vm.$t('add_new_travel_party'))),"rightMenu":[
    {
      text: _vm.$t('get_contacts_via_artists'),
      value: 'get_contacts_button',
    }
  ]},on:{"add_click":_vm.addContactRelation,"menuClick":_vm.onMenuClick}},[_c('div',{staticClass:"ut-flex",staticStyle:{"flex-wrap":"wrap"}},_vm._l((_vm.booking.contact_relations),function(contact){return _c('Badge',{key:contact.contact_id,attrs:{"item":contact,"stringKey":'contact_name'},on:{"delete":_vm.removeContactRelation}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }